import { InjectionToken } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { DataObject } from '@shared/models/data-object.model';

export const FormControlMakerToken = new InjectionToken<FormControlMaker>('FormControlMaker');

export interface FormControlMaker<T = any> {
  makeControlEntry(config: T, parentForm: UntypedFormGroup, data: DataObject): AbstractControl;
}
